import type { ShopDto } from "@babackapp/private-api-client/types";

/** Absent reads as `false`: shops predating the toggle disapprove in one click.
 * Mirrors the backend helper of the same name. */
export function isDisapprovalReasonAsked(shop: ShopDto): boolean {
  return shop.preferences.notifications.askDisapprovalReason ?? false;
}
